<template>
  <validation-observer
    v-if="!isAdditional"
    v-show="isRenderAfterFullfilled"
    v-slot="observer"
    slim
  >
    <form-section
      id="children"
      :validated="formObserver.validated"
      v-bind="observer"
    >
      <form-row
        label="How many children do you have that are aged 16 and under?"
        :error="formObserver.validated && observer.invalid"
      >
        <template slot="helpText">
          <p>
            <strong>Why ask this?</strong>
            <br>
            Insurance providers want to know because people who have children with them tend to drive more cautiously.
          </p>
        </template>
        <validation-provider
          v-slot="{ failed }"
          :vid="`${stepId}_children`"
          name="Children"
          :rules="{ is_not: { other: null } }"
        >
          <radio
            v-model="childrenGenericModel"
            :name="`${stepId}-children`"
            :data-test="fieldTrackerId.main"
            :items="childrenGenericOptions"
            :error="failed"
            :error-messages="failed ? ['Please select an option.'] : []"
            column
            return-object
          />
        </validation-provider>
      </form-row>
      <form-row
        v-if="childrenGenericModel !== null && !constants.DRIVER_CHILDREN_FAVORITES.includes(childrenGenericModel)"
        gap="16"
      >
        <validation-provider
          v-slot="{ errors }"
          :vid="`${stepId}_children`"
          name="Children (more)"
          rules="listOptionRequired"
        >
          <qz-select
            v-model="questionData.children"
            :data-test="fieldTrackerId.other"
            :items="childrenOtherOptions"
            :error-messages="errors"
            :placeholder="
              helpers.getPlaceholderResponsiveText(
                !isAdditional
                  ? 'Please select how many children you have'
                  : 'Please select how many children they have',
                isMobile
              )
            "
          />
        </validation-provider>
      </form-row>
    </form-section>
  </validation-observer>
</template>

<script>
import {
  omit,
  pick,
  snakeCase,
} from 'lodash';
import QuestionBase from './Base';

export default {
  name: 'question-children',
  extends: QuestionBase,
  data () {
    return {
      fields: ['children'],
    };
  },
  computed: {
    childrenGenericOptions () {
      return [
        ...this.helpers.createOptions({
          source: pick(this.constants.DRIVER_CHILDREN, this.constants.DRIVER_CHILDREN_FAVORITES),
          asNumbers: true,
        }),
        {
          ...this.constants.OTHER_OPTIONS,
          text: this.constants.DRIVER_CHILDREN_MORE_LABEL,
        },
      ];
    },
    childrenOtherOptions () {
      return this.helpers.createOptions({
        source: omit(this.constants.DRIVER_CHILDREN, this.constants.DRIVER_CHILDREN_FAVORITES),
        asNumbers: true,
      });
    },
    childrenGenericModel: {
      get () {
        if (this.questionData.children === null) return null;
        return this.constants.DRIVER_CHILDREN_FAVORITES.includes(this.stepData.children) ? this.stepData.children : true;
      },
      set (val) {
        this.questionData.children = val.logical ? val.logicalValue : val.value;
      },
    },
    fieldTrackerId () {
      return {
        main: snakeCase(this.questionFields.children),
        other: `${snakeCase(this.questionFields.children)}_other`,
      };
    },
  },
};
</script>
